import React from 'react'
import PropTypes from 'prop-types'

// ag-grid
import { AgGridReact } from 'ag-grid-react'
import CheckboxRenderer from './CheckboxRenderer.js'

// define a custom renderer for checkboxes that can be used
const components = {
  checkboxRenderer: CheckboxRenderer
}

export default function AtlasGrid ({ columnHeadings, rowData, columnTypes }) {
  const [gridApi, setGridApi] = React.useState(null)

  const onGridReady = (params) => {
    setGridApi(params.api)
  }

  React.useEffect(() => {
    if (gridApi !== null) {
      gridApi.setColumnDefs(columnHeadings)

      gridApi.getToolPanelInstance('columns').collapseColumnGroups()

      const allColumnIds = []

      gridApi.gridOptionsWrapper.gridOptions.columnApi.getColumns().forEach(function (column) {
        allColumnIds.push(column.colId)
      })

      resizeGrid()
    }
  }, [gridApi])

  React.useEffect(() => {
    if (gridApi !== null) {
      gridApi.setColumnDefs(columnHeadings)
    }
  }, [columnHeadings])

  const resizeGrid = () => {
    if (gridApi !== null) {
      // gridApi.gridOptionsWrapper.gridOptions.columnApi.autoSizeAllColumns()
      // gridApi.sizeColumnsToFit()
    }
  }

  return (rowData ? <div style={{ width: '100%', height: '100%' }}>
    <div style={{ height: '700px', boxSizing: 'border-box' }}>
      <div
        id="atlasGrid"
        style={{
          height: '100%',
          width: '100%'
        }}
        className="ag-theme-alpine"
      >
        <AgGridReact
          defaultColDef={{
            flex: 1,
            minWidth: 100,
            editable: true,
            floatingFilter: true,
            resizable: true,
            sortable: true
          }}
          defaultColGroupDef={{ marryChildren: true }}
          suppressAggFuncInHeader={true}
          columnTypes={columnTypes}
          rowData={rowData}
          onGridReady={onGridReady}
          onToolPanelVisibleChanged={resizeGrid}
          onColumnVisible={resizeGrid}
          enableRangeSelection={true}
          enableCharts={true}
          statusBar={{
            statusPanels: [
              { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
              { statusPanel: 'agAggregationComponent' }
            ]
          }}
          sideBar={{
            toolPanels: [
              {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                  suppressRowGroups: true,
                  suppressValues: true,
                  suppressPivots: true,
                  suppressPivotMode: true,
                  suppressColumnFilter: true,
                  suppressColumnSelectAll: false,
                  suppressColumnExpandAll: false
                }
              },
              {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel'
              }
            ],
            position: 'left',
            defaultToolPanel: 'columns',
            hiddenByDefault: false
          }}
          animateRows={true}
          rowDragManaged={false}
          rowSelection={'multiple'}
          components={components}
        >
        </AgGridReact>
      </div>
    </div>
  </div> : <div></div>
  )
}

AtlasGrid.propTypes = {
  columnHeadings: PropTypes.array,
  rowData: PropTypes.array,
  columnTypes: PropTypes.object
}
